<script setup>
import { ref } from 'vue';
import SalesCommissionParticipantCard from './SalesCommissionParticipantCard.vue';
import SalesCommissionParticipantPaymentModal from './SalesCommissionParticipantPaymentModal.vue';

const props = defineProps({
  banks: { type: Array, default: () => [] },
  errors: { type: Object, default: () => ({}) },
  group: { type: String, required: true },
  options: { type: Array, default: () => [] },
  pixKeys: { type: Array, default: () => [] },
  value: { type: Object, required: true },
});

const emit = defineEmits(['updateParticipant']);
const paymentIndex = ref(-1);
const savePayment = participant => {
  Object.entries(participant).forEach(([field, value]) => {
    emit('updateParticipant', props.group, paymentIndex.value, field, value);
  });
  paymentIndex.value = -1;
};
</script>

<template>
  <div>
    <SalesCommissionParticipantCard
      v-for="(participant, index) in value.rows"
      :key="index"
      :participant="participant"
      :options="options"
      :banks="banks"
      :errors="errors.rows?.[index] || {}"
      @update="
        (field, nextValue) =>
          emit('updateParticipant', group, index, field, nextValue)
      "
      @edit-payment="paymentIndex = index"
    />
  </div>
  <SalesCommissionParticipantPaymentModal
    v-if="paymentIndex >= 0"
    :show="paymentIndex >= 0"
    :participant="value.rows[paymentIndex]"
    :banks="banks"
    :pix-keys="pixKeys"
    :errors="errors.rows?.[paymentIndex] || {}"
    @close="paymentIndex = -1"
    @save="savePayment"
  />
</template>
